<script setup>
import { pickFields } from '../../common/pick-fields'

const emit = defineEmits(['update:modelValue', 'selected', 'setDetails'])
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: Object,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
})

function getOptionId(valueId){
    return `${props.name}-${valueId}`
}

function onOptionClick(option){
    if(option.id !== props.modelValue.id){
        emit('update:modelValue', pickFields(option, Object.keys(props.modelValue)));
    }

    emit('selected');

    if(option.description){
        emit('setDetails', {
            title: option.title,
            description: option.description,
            image: option.image
        });
    }
}

</script>

<template>
    <div class="ConfiguratorList -tw-mx-2.5">
        <h3 v-if="props.label" v-text="props.label" class="tw-text-brand-500 tw-text-xl md:tw-text-xl lg:tw-text-2xl tw-font-medium tw-mb-4 tw-px-3"></h3>

        <div class="tw-grid tw-auto-rows-fr md:tw-grid-cols-2 md:tw-gap-x-4 lg:tw-grid-cols-1">
            <div
                v-for="option in props.options"
                :key="option.id"
                class="ConfiguratorItem ConfiguratorOption"
            >
                <input
                    type="radio"
                    :value="getOptionId(option.id)"
                    :id="getOptionId(option.id)"
                    :name="props.name"
                    :checked="props.modelValue.id === option.id"
                    @click="onOptionClick(option)"
                    class="tw-sr-only"
                >

                <label
                    class="tw-group tw-h-full tw-p-2 tw-cursor-pointer tw-transition-all hover:tw-shadow-configurator hover:tw-z-10"
                    :for="getOptionId(option.id)"
                >
                    <div class="tw-w-full tw-flex tw-flex-row tw-gap-4 tw-justify-start tw-items-stretch">
                        <div
                            class="tw-relative tw-overflow-hidden tw-bg-gray-100 tw-rounded-sm tw-w-4/12 lg:tw-w-full xxl:tw-w-4/12"
                            :class="{
                                'tw-aspect-4/3': ['floor', 'room'].includes(props.name),
                                'tw-aspect-5/2 md:tw-aspect-12/7': !['floor', 'room'].includes(props.name),
                                'tw-border tw-border-gray-100': props.name === 'material' && option.title.includes('RAL 9016')
                            }">

                            <img
                                v-if="option.image"
                                :src="option.image"
                                class="tw-absolute tw-left-0 tw-top-0 tw-size-full tw-object-cover"
                            />

                            <div
                                v-if="props.name === 'material'"
                                class="ConfiguratorItemModel"
                                :class="option.tuerModelle[0]"
                            ></div>
                        </div>

                        <div class="TextContent tw-relative tw-text-gray-700 tw-flex tw-flex-col tw-justify-center tw-w-8/12 tw-py-1 lg:tw-w-full xxl:tw-py-3 xxl:tw-w-8/12 after:tw-content-[''] after:tw-absolute after:tw-left-0 after:tw-bottom-0 after:tw-w-full after:tw-h-px after:tw-bg-gray-100 after:tw-transition-colors after:tw-duration-300 group-hover:after:tw-bg-transparent">
                            <div v-if="props.name === 'material'">
                                <p class="tw-font-medium md:tw-text-lg lg:tw-leading-snug xl:tw-text-16 xl:tw-leading-normal" v-if="option.title" v-text="option.title"></p>
                                <p class="tw-font-medium md:tw-text-lg lg:tw-leading-snug xl:tw-text-20 xl:tw-leading-normal" v-if="option.teaser" v-text="option.teaser"></p>
                            </div>
                            <div v-else>
                                <p class="tw-font-medium md:tw-text-lg lg:tw-leading-snug xl:tw-text-20 xl:tw-leading-normal" v-if="option.title" v-text="option.title"></p>
                                <p class="tw-text-14" v-if="option.teaser" v-text="option.teaser"></p>
                            </div>
                        </div>
                    </div>
                </label>
            </div>
        </div>
    </div>
</template>